import { axiosClient } from "services/axios";

export function deletePriceListItem(pricelistid: string | number) {
  return axiosClient.delete("stores/pricelist", {
    params: { pricelistid: Number(pricelistid) },
  });
}
